import React from "react"
import { withRouter } from 'react-router-dom'
import StorageTable from "../../StorageTable"

const Storage = ({ match }) =>
  <StorageTable
    collection={"screeners"}
    modelID={match.params.videoID}/>

export default withRouter(Storage)